import useStore from '../data/store/use';

let resolveCallback;
function useModal() {
  const {
    state: { modal },
    actions: { setModal },
  } = useStore();

  const closeModal = () => {
    setModal({
      show: false,
      title: '',
      content: '',
    });
  };

  const showModal = ({ title, content }) => {
    setModal({
      show: true,
      title,
      content,
    });
  };

  const onModal = () => {
    closeModal();
    resolveCallback(true);
  };

  return { modal, onModal, showModal, closeModal };
}

export default useModal;
